<ion-button (click)="setInputMode()" [class.selected]="(inputMode$ | async) === mode" color="primary" fill="outline">
  <ion-icon [name]="icon" slot="start" />
  <!-- if the language file takes time to load, the button is first treated as an icon only button.
  To avoid layout shift for the icon, we use &nbsp; in that case -->
  {{ ('translate.input.' + mode | transloco) || '&nbsp;' }}
</ion-button>
